import BaseLayout from '@/components/PageLayout';
import SEO from '@/components/utils/SEO';
import Product from 'lowcode/pages/product';
import { queryEditorDetailOnline } from 'lowcode/utils/service';
import * as LowCompIndex from 'lowcomp/plugins/index-series/indexS';
import * as LowCompSeries from 'lowcomp/plugins/series-series/indexS';

const allTemp = {
    ...LowCompIndex,
    ...LowCompSeries,
};
export default function Page({ tempData, locale, id }: any) {
    const thePage = tempData.thePage || {};
    return (
        <BaseLayout>
            <SEO title={thePage.title || 'series'} description={thePage.description || 'series'} />
            <Product id={id} data={tempData} allTemp={allTemp} />
        </BaseLayout>
    );
}

export async function getServerSideProps({ params, locale }: any) {
    const id = params.id[0];
    const tempData: any = await queryEditorDetailOnline(`series/${id}`, locale);

    return {
        props: {
            tempData,
            locale,
            id,
        },
    };
}
